<template>
<base-popup-dialog v-model="value" :maxBodyWidth="700" :maxBodyHeight="400" title="REP Admin Groups">
<div slot="dialogBody">
<v-container class="grey lighten-5">
                        <v-row >
                        <v-col cols="6" md="4">
                            <v-card class="ma-0 pa-0" outlined height="400px">
                                <v-list>
                                    <v-list-item-group v-model="selectedAdmins">
                                       <v-list-item
                                            v-for="(admin, index) in adminLabels"
                                            :key="index"
                                            @click="onItemClick(admin)"                                            
                                            >
                                                <v-list-item-title dense class="mb-0 pb-0">
                                                    {{admin}}
                                                </v-list-item-title>
                                       </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="8" class="ma-0 pa-0">
                            <v-container>
                                <v-row no-gutters dense>
                                        <v-col>
                                            <v-text-field 
                                            dense
                                            outlined 
                                            placeholder="type name to filter"
                                            v-model="textToFilter">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="0" md="0" class="ml-2">
                                            <v-icon v-if="!this.clear_filter_icon">mdi-filter</v-icon>
                                            <v-icon v-if="this.clear_filter_icon" @click="clearTextToFilter()">mdi-filter-remove</v-icon>
                                        </v-col>
                                </v-row>
                                <v-row no-gutters dense >
                                    <v-col class="ma-0 mr-2 mb-2">
                                        <v-card class="ma-0 pa-0" outlined height="335px">
                                           <v-list height="330" max-height="330"
                                                    class="overflow-y-auto">
                                                <v-list-item-group>
                                                <v-list-item v-for="users in adminUsersFilter"
                                                    :key="users.name">
                                                    <v-checkbox class="pb-0 mb-0 ma-0 pa-0" 
                                                    dense 
                                                    v-model="users[1]" 
                                                    :label="adminNameWithEmail(users[0])">                                                
                                                        </v-checkbox>                                               
                                                </v-list-item>
                                                </v-list-item-group>
                                            </v-list>                                                                                  
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>                            
                        </v-col>                       
                        </v-row>                        
					</v-container>
</div>
<div slot="dialogFooter">
    <v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="mb-2 mr-2" text color="primary" @click="applyChanges">save</v-btn>					
					<v-btn class="mb-2 mr-2" text color="primary" @click="onCloseDlg">Cancel</v-btn>
				</v-card-actions>
</div>    
</base-popup-dialog>	
</template>

<script>
import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";

export default {
    props: ["value", "admins", "internalUsers"],
    components: {
        "base-popup-dialog": BasePopUpDialog
        },
    data(){
        return {
           adminLabels:['System Admin','Communication Admin','Showcase Admin'],
           local_admins: this.admins,
           showcaseAdmins: [],
           newsAdmins: [],
           commAdmins: [],
           systemAdmins: [],
           local_internalUsers: this.internalUsers,
           showcaseAdminNames: [],
           newsAdminNames: [],
           commAdminNames: [],
           systemAdminNames: [],
           adminUsers: null,
           systemAdminUsers: null,
           showcaseAdminUsers: null,
           newsAdminUsers: null,
           commAdminUsers: null,
           textToFilter: '',
           adminsActionMessage: '',
           actionFlag: false,
           clear_filter_icon: false,
           selectedAdmins: 0
           }        
    },
   computed: {
        adminUsersFilter () {
            console.log("inside adminUsers() computed method");
            if (!this.textToFilter) {
                return this.adminUsers; 
            } else {
                return this.adminUsers.filter(admin => {
                    return admin[0].toLowerCase().match(this.textToFilter);
                    });
                }
            }
        },
            
    watch:{
        textToFilter(){
            if(this.textToFilter.length > 0){
                this.clear_filter_icon = true;
            }else{
               this.clear_filter_icon = false; 
            }
        }
    },
    methods:{
        adminNameWithEmail (username){
            let userNameWithEmail;
            this.internalUsers.forEach(users => {
                if(users.id.toLowerCase() == username.toLowerCase()){
                    userNameWithEmail = username+" ("+users.email+")";                    
                }
            });
            return userNameWithEmail;            
        },
        onCloseDlg(){
            this.$emit("input",false);
            this.$emit("closeSettingDialog");
        },
        onItemClick(selectedAdminType){
            console.log("inside onItemClick() method");
            
            if(selectedAdminType == 'Showcase Admin'){   
                this.selectedAdmins = 0;   
                this.adminUsers = this.showcaseAdminUsers;
            }else if(selectedAdminType == 'Communication Admin'){
                this.selectedAdmins = 1;
                this.adminUsers = this.commAdminUsers;
            }else if(selectedAdminType == 'System Admin'){
                this.selectedAdmins = 2;
                this.adminUsers = this.systemAdminUsers;
            }else if(selectedAdminType == 'News Admin'){
                this.selectedAdmins = 3;
                this.adminUsers = this.newsAdminUsers;
            }
        },
        clearTextToFilter(){
            this.textToFilter = '';
        },        
        setAdminUsers(){
            console.log("inside setAdminUsers() method");
            if(this.showcaseAdminUsers == null){
                this.internalUsers.forEach(user => {
                    const userid = (user.id).toLowerCase();
                    if(!this.showcaseAdminNames.includes(userid)){
                        this.showcaseAdmins.push([userid,false]);
                        this.showcaseAdminNames.push(userid);
                    } 
                });
                this.showcaseAdminUsers = this.showcaseAdmins;
            }
            if(this.commAdminUsers == null){
                this.internalUsers.forEach(user => {
                    const userid = (user.id).toLowerCase();
                    if(!this.commAdminNames.includes(userid)){
                        this.commAdmins.push([userid,false]);
                        this.commAdminNames.push(userid);
                    }
                });
                this.commAdminUsers = this.commAdmins;
            }
            if(this.newsAdminUsers == null){
                this.internalUsers.forEach(user => {
                    const userid = (user.id).toLowerCase();
                    if(!this.newsAdminNames.includes(userid)){
                        this.newsAdmins.push([userid, false]);
                        this.newsAdminNames.push(userid);
                    }
                });
                this.newsAdminUsers = this.newsAdmins; 
            }
            this.adminUsers = this.systemAdminUsers;
            this.selectedAdmins = 0;   
        },
        async applyChanges(){
            console.log("inside applyChanges() method.");
            const formdata = new FormData();
            const sysAdminsToSave = [];
            const showcaseAdminsToSave = [];
            const newsAdminsToSave = [];
            const commAdminsToSave = [];
            
            this.systemAdminUsers.forEach(admin =>{
                if(admin[1] == true){
                    sysAdminsToSave.push(admin[0]);
                }
            });
            this.showcaseAdminUsers.forEach(admin =>{
                if(admin[1] == true){
                    showcaseAdminsToSave.push(admin[0]);
                }
            });
            this.newsAdminUsers.forEach(admin =>{
                if(admin[1] == true){
                    newsAdminsToSave.push(admin[0]);
                }
            });
            this.commAdminUsers.forEach(admin =>{
                if(admin[1] == true){
                    commAdminsToSave.push(admin[0]);
                }
            });
            console.log("sysAdminsToSave: "+sysAdminsToSave);
            console.log("showcaseAdminsToSave: "+showcaseAdminsToSave);
            console.log("commAdminsToSave: "+commAdminsToSave);
            console.log("newsAdminsToSave: "+newsAdminsToSave);

            formdata.append("showcaseAdmins", showcaseAdminsToSave);
            formdata.append("communicationAdmins", commAdminsToSave);
            formdata.append("newsAdmins", newsAdminsToSave);
            formdata.append("systemAdmins", sysAdminsToSave);
            await this.$store.dispatch("saveAdmins", {entity:formdata, callbackFunc:()=>{
                    this.$emit("input", false);
                    this.$emit("closeSettingDialog");
				}});
        }
    },

    mounted(){
        this.setAdminUsers();
    },


    created(){
        const sysAdmniLabel = ('System Admin').toLowerCase();
        const showcaseAdmniLabel = ('Showcase Admin').toLowerCase();
        const commAdmniLabel = ('Communication Admin').toLowerCase();
        const newsAdmniLabel = ('News Admin').toLowerCase();

        console.log("inside created() lifecycle");
        this.local_admins.forEach(admin => {
            const adminName = (admin.dataAccessGroup).toLowerCase();
            if(admin.repUserGroup.toLowerCase() == sysAdmniLabel && !this.systemAdminNames.includes(adminName)){               
                this.systemAdmins.push([adminName, true]);
                this.systemAdminNames.push(adminName);
            }else if(admin.repUserGroup.toLowerCase() == showcaseAdmniLabel && !this.showcaseAdminNames.includes(adminName)){
                this.showcaseAdmins.push([adminName,true]);
                this.showcaseAdminNames.push(adminName);
            }else if(admin.repUserGroup.toLowerCase() == commAdmniLabel && !this.commAdminNames.includes(adminName)){
                this.commAdmins.push([adminName,1]);  
                this.commAdminNames.push(adminName);              
            }else if(admin.repUserGroup.toLowerCase() == newsAdmniLabel && !this.newsAdminNames.includes(adminName)){
                this.newsAdmins.push([adminName, true]);
                this.newsAdminNames.push(adminName);
            }
        });
        console.log(this.systemAdminNames);
            this.internalUsers.forEach(user => {
                const userid = (user.id).toLowerCase();
                if(!this.systemAdminNames.includes(userid)){
                    this.systemAdmins.push([userid, false]);
                    this.systemAdminNames.push(userid);
                }
            });            
        this.adminUsers = this.systemAdmins; 
        this.systemAdminUsers = this.systemAdmins;       
    }
}
</script>
<style scoped>
.v-list {
  height: 100px;
}
</style>